import React, { memo, useCallback, useState, ReactText, MouseEvent, FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@blocs.i18n';
import FormikInput from '@minecraft.formik-input';

const StyledFormikPwInputContainer = styled.div`
  position: relative;
`;

const StyledFormikPwButton = styled.button`
  position: absolute;
  right: 2.1875rem;
  top: 1px;
  height: 2.25rem;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.primary.ltGrey1};
  border: none;
  background: ${(props) => props.theme.colors.primary.white};
  outline: none;
  appearance: none;
`;

type Props = {
  name: string;
  showText?: ReactText;
  hideText?: ReactText;
  handleEnter?: () => void;
  id?: string;
};

const getInputType = (show: boolean) => (show ? 'text' : 'password');

const FormikPassword: FC<Props> = ({ hideText, showText, handleEnter, ...props }) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(false);
  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      setIsShow(!isShow);
    },
    [isShow]
  );
  const intlHideText = hideText || t('common:button.hide');
  const intlShowText = showText || t('common:button.show');

  return (
    <StyledFormikPwInputContainer
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleEnter?.();
        }
      }}
    >
      <FormikInput {...props} type={getInputType(isShow)} />
      <StyledFormikPwButton onClick={handleClick}>{isShow ? intlHideText : intlShowText}</StyledFormikPwButton>
    </StyledFormikPwInputContainer>
  );
};

export default memo<Props>(FormikPassword);
